import React from "react";

type Props = {
  className: string;
};

export default function CordLeft({ className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="264"
      height="332"
      fill="none"
      className={className}
      preserveAspectRatio="xMidYMax meet"
      viewBox="0 0 264 332"
    >
      <path
        fill="#22304C"
        d="M192.4 290.2c-28.5 6-105.9 13.3-119.2-23.7-13.7-38-5.7-61.3 4.3-90.7C86 151.6 95.3 124.2 94.1 84c-1-28.8-11.6-50.6-32-64.7C46.7 8.5 16.4 2.6-4 .9v20c16.5 1.6 42.6 6.7 54.7 15 15.1 10.5 22.7 26.5 23.3 49 1 36.5-7.4 61-15.5 84.7-10.5 30.5-20.3 59.3-4.3 104 12.4 34 54 41.7 89 41.7 27.6 0 51-4.8 53.3-5.2l-4-19.9z"
      ></path>
      <path
        fill="#22304C"
        d="M260.4 310.2h-22v-14.8h22c2 0 3.5-1.5 3.5-3.5s-1.5-3.5-3.5-3.5h-22V276h-27.6a27.6 27.6 0 100 55.2h27.7v-13.6h21.9c2 0 3.5-1.5 3.5-3.5 0-2.2-1.7-3.9-3.5-3.9z"
      ></path>
    </svg>
  );
}
